// Google Analytics 4 helpers + first-party event tracking (admin conversions dashboard)
const GA_ID = process.env.REACT_APP_GA_ID;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

let initialised = false;

export const isGAEnabled = () => Boolean(GA_ID);

export function initGA() {
  if (initialised || !GA_ID || typeof window === "undefined") return;
  initialised = true;

  // Inject GA4 gtag.js
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, {
    send_page_view: false, // we send manually on route change
    anonymize_ip: true,
  });
}

export function trackPageview(path, title) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}

// Fire-and-forget first-party event -> /api/track (powers admin conversions dashboard)
// Also used for search-term analytics (event: "search").
export function trackServerEvent(event, params = {}) {
  if (typeof window === "undefined" || !BACKEND) return;
  try {
    fetch(`${BACKEND}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event,
        page: window.location.pathname,
        placement: params.placement || "",
        language: localStorage.getItem("rihaai_lang") || "en",
        detail: (params.detail || "").slice(0, 200),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* tracking must never break UX */
  }
}

// Delegated listener for all tel: (call) and wa.me (WhatsApp) clicks.
// Single source of truth — individual buttons do not track themselves.
export function installCallTracker() {
  if (typeof document === "undefined") return;
  document.addEventListener("click", (e) => {
    const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href*="wa.me"]');
    if (!a) return;
    const href = a.getAttribute("href") || "";
    const placement = a.getAttribute("data-testid") || "";
    if (href.includes("wa.me")) {
      trackEvent("whatsapp_click", { link_location: window.location.pathname });
      trackServerEvent("whatsapp_click", { placement });
    } else {
      trackEvent("phone_call_click", {
        phone_number: href.replace("tel:", ""),
        link_text: (a.textContent || "").trim().slice(0, 80),
        link_location: window.location.pathname,
      });
      trackServerEvent("call_click", { placement });
    }
  });
}
